import { notifications } from "@mantine/notifications";
import colors from "../utils/colors";
import { getMessages } from "../utils/translations";

const POSITION = 'top-right';
const locale = localStorage.getItem('locale') || 'pl-PL';
const messages = getMessages(locale as any);

export const showInfoNotification = (message: string, title?: string, duration?: number) => 
    notifications.show({
    position: POSITION,
    title: title ?? (messages['info'] || 'Information'),
    message,
    color: colors.custom36s,
    style: { backgroundColor: colors.customBg2, top: '-10px' },
    autoClose: duration ?? 3000
});

export const showSuccessNotification = (message: string, title?: string, duration?: number) => 
    notifications.show({
    position: POSITION,
    title: title ?? (messages['success'] || 'Success'),
    message,
    color: colors.green,
    style: { backgroundColor: colors.customBg2, top: '-10px' },
    autoClose: duration ?? 3000
});

export const showErrorNotification = (message: string, title?: string, duration?: number) => 
    notifications.show({
    position: POSITION,
    title: title ?? (messages['error'] || 'Error'),
    message,
    color: colors.red,
    style: { backgroundColor: colors.customBg2, top: '-10px' },
    autoClose: duration ?? 3000
})